import script from "./SpreadCell.vue?vue&type=script&setup=true&lang=js"
export * from "./SpreadCell.vue?vue&type=script&setup=true&lang=js"

import "./SpreadCell.vue?vue&type=style&index=0&id=4800cf80&lang=css"

const __exports__ = script;

export default __exports__